module.exports = __webpack_public_path__ + "static/media/pic3.6acd46d4.jpg";